import { RootState } from '@reducers';

export const selectMobileNumber = (state: RootState) => state.userRegistrationReducer.mobileNumber;
